import { normalizeTextString } from '../normalizeTextString';

export const calculatePrefixPath = (path: string, prefix: string) => {
  const normalizedPath = normalizeTextString(path, true);

  return prefix && !path.includes(`/${prefix}/`)
    ? `/${prefix}${normalizedPath}`
    : normalizedPath;
};
